document.addEventListener("DOMContentLoaded", async () => {
    // TEMPORARILY DISABLED FOR WEEKEND - REMOVE THIS COMMENT TO RE-ENABLE
    return;

  const stockEl = document.getElementById("cart-stock-data");
  if (!stockEl) return;

  const stockData = JSON.parse(stockEl.textContent);

  // Fetch the latest cart
  const cartResponse = await fetch('/cart.js');
  const cart = await cartResponse.json();

  for (const item of stockData.items) {
    const cartItem = cart.items.find(c => c.variant_id === item.id);
    if (!cartItem) continue;

    const cartPreorder = cartItem.properties?.["Pre-Order"] || null;

    // Update Pre-Order if there is a lead time
    const shouldUpdatePreorder = item.preorder_lead_time && cartPreorder !== item.preorder_lead_time;

    // Remove item only if preorder_lead_time is null and inventory is empty
    const shouldRemove = !item.preorder_lead_time && item.inventory_quantity <= 0 && item.quantity_in_cart > 0;

    if (!shouldUpdatePreorder && !shouldRemove) continue;

    const formData = {
      id: cartItem.key,
      quantity: shouldRemove ? 0 : cartItem.quantity,
      properties: shouldUpdatePreorder
        ? { ...cartItem.properties, "Pre-Order": item.preorder_lead_time }
        : cartItem.properties,
      sections: 'cart-drawer-template',
      sections_url: window.PXUTheme.routes.cart_url
    };

    try {
      const response = await fetch(window.PXUTheme.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(formData)
      }).then(res => res.json());

      // --- Manually refresh the cart drawer ---
      const sectionsHTML = response.sections['cart-drawer-template'];
      if (sectionsHTML) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionsHTML, 'text/html');
        const newCartDrawer = doc.querySelector('[data-cart-drawer]');
        const currentDrawer = document.querySelector('[data-cart-drawer]');
        if (currentDrawer && newCartDrawer) {
          currentDrawer.innerHTML = newCartDrawer.innerHTML;
          if(shouldRemove) {
            showCartValidationToast(`Sorry, <a href="${item.url}">${item.title}</a> is no longer available and has been removed from your cart.`);
          }
          console.log(`✅ Cart drawer updated: ${item.title}${shouldRemove ? " (removed)" : ""}`);
        }
      }

      // --- Update cart count in the header ---
      const cartCountEl = document.querySelector('[data-cart-count]');
      if (cartCountEl) {
        cartCountEl.textContent = response.item_count || 0;
      }

    } catch (err) {
      console.error(`Error updating cart item "${item.title}":`, err);
    }
  }

  function showCartValidationToast(message) {
    const cartValidationToast = document.getElementById("cart-validation");
    cartValidationToast.innerHTML = message;
    cartValidationToast.classList.add("show");

    setTimeout(() => {
      cartValidationToast.classList.remove("show");
    }, 10000);
  }
  
});
